import type { TrackerChatMessage } from '@/components/Messenger/types/chatMessageTypes';

/** Текст ассистента для UI: только text-парты, без инструментов и reasoning. */
export function assistantUiTextFromParts(parts: TrackerChatMessage['parts'] | undefined): string {
  if (!parts?.length) return '';
  const lines: string[] = [];
  for (const part of parts) {
    if (part.type === 'text' && 'text' in part) {
      const t = typeof part.text === 'string' ? part.text.trim() : '';
      if (t) lines.push(t);
    }
  }
  return lines.join('\n\n');
}
